import React from 'react';
import styled from '@emotion/styled';
import { NavLink } from 'react-router-dom';

import { Drawer as MuiDrawer, ListItemButton, Typography, Box, IconButton } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import logo from '../../vendor/pinpoint_white.png';

import SidebarNav from './SidebarNav';
import SidebarUserMenu from './SidebarUserMenu';
import SidebarProfileInfo from './SidebarProfileInfo';

const Drawer = styled(MuiDrawer)`
  border-right: 0;
  > div {
    border-right: 0;
    display: flex;
    flex-direction: column;
  }
`;

const Brand = styled(ListItemButton)`
  font-size: ${(props) => props.theme.typography.h1.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  color: ${(props) => props.theme.sidebar.header.color};
  background-color: ${(props) => props.theme.sidebar.header.background};
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 56px;
  padding-left: ${(props) => props.theme.spacing(6)};
  padding-right: ${(props) => props.theme.spacing(6)};
  justify-content: center;
  cursor: pointer;
  flex-grow: 0;
  position: relative;

  ${(props) => props.theme.breakpoints.up('sm')} {
    min-height: 64px;
    text-align: center;
    font-weight: 500;
  }

  &:hover {
    background-color: ${(props) => props.theme.sidebar.header.background};
  }
`;

const SidebarContent = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const MobileMenuButton = styled(IconButton)`
  position: absolute;
  left: 8px;
  color: ${(props) => props.theme.sidebar.header.color};
  ${(props) => props.theme.breakpoints.up('md')} {
    display: none;
  }
`;

const Sidebar = ({ items, onDrawerToggle, showFooter = true, ...rest }) => (
  <Drawer variant="permanent" {...rest}>
    <SidebarContent>
      <Brand component={NavLink} to="/">
        {onDrawerToggle && (
          <MobileMenuButton onClick={onDrawerToggle} size="small">
            <MenuIcon />
          </MobileMenuButton>
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img style={{ maxHeight: '30px' }} src={logo} alt="" />
          <Typography variant="h4" style={{ textAlign: 'center' }}>
            Mina sidor
          </Typography>
        </div>
      </Brand>
      <SidebarNav items={items} />
      <SidebarProfileInfo />
      {showFooter && <SidebarUserMenu />}
    </SidebarContent>
  </Drawer>
);

export default Sidebar;
